module.exports = __webpack_public_path__ + "img/40_pourcent.1b8f6c8f.png";